import m from 'mithril'
import stream from 'mithril/stream'
import classNames from 'classnames'
import {
    Search
} from '../models'
import {
    TextBox,
    RangeSilder
} from '../components'
import RangeSlider from '../components/form/range-slider'
import isMobile from '../lib/detect-mobile'

class SearchFormMrt {
    constructor() {
        var i = 0
        this.show = false
        this.search = {
            categories: [],
            districts: [],
            houseStyles: [],
            houseTypes: [],
            pains: [],
            conditions: [],
            keyword: "",
            range: []
        }
        this.keyword = ""
        this.chosen_distrcts = []
        this.chosen_categories = []
        this.chosen_houseStyles = []
        this.chosen_houseTypes = []
        this.chosen_pains = []
        this.chosen_conditions = []

        this.search_item = {
            categories: [],
            districts: [],
            houseStyles: [],
            houseTypes: [],
            pains: [],
            conditions: [],
            keyword: "",
            range: []
        }

        this.min = stream(0)
        this.max = stream(50000)
        this.start = stream(0)
        this.end = stream(50000)

        Search.fetchMrt().then((responsive) => {
            this.search = responsive
            this.search.districts.map((district) => {
                this.chosen_distrcts.push(district.id)
            })
            this.search.categories.map((category) => {
                this.chosen_categories.push(category.id)
            })
            this.search.houseStyles.map((houseStyle) => {
                this.chosen_houseStyles.push(houseStyle.id)
            })
            this.search.houseTypes.map((houseType) => {
                this.chosen_houseTypes.push(houseType.id)
            })
            this.search.pains.map((pain) => {
                this.chosen_pains.push(pain.id)
            })
        })

        this.item = []
        for (i = 0; i < 10; i++) {
            this.item[i] = []
        }



    }

    view(vnode) {

        return m("form[id='search_form'][method='post']",
            m("input[id='json_value']", {
                name: 'search',
                type: 'hidden',
                value: JSON.stringify(this.search_item),
            }),
            m("input[id='result']", {
                name: 'result',
                type: 'hidden',
                value: "",
            }),
            [
                m(".dropdown",
                    [
                        m("a.btn.btn-outline-secondary.dropdown-toggle.btn-block.template-select[aria-expanded='false'][aria-haspopup='true'][data-toggle='dropdown'][href='#'][id='dropdownMenuButton']",
                            "房屋選項"
                        ),
                        m(".dropdown-menu[aria-labelledby='dropdownMenuButton']", {
                            style: {
                                "width": "700px"
                            }
                        },
                            m(".row.no-gutters.py-3",
                                [
                                    m(".col.pl-20",
                                        [
                                            m(".h5.pt-20",
                                                "依物件類型"
                                            ),
                                            m("ul.other-features",
                                                m("li",
                                                    [
                                                        m("input[id='Al-1'][type='checkbox']", {
                                                            checked: this.chosen_categories.length == this.search.categories.length,
                                                            onclick: (e) => {
                                                                if (this.chosen_categories.length == this.search.categories.length) {
                                                                    this.chosen_categories = []
                                                                } else {
                                                                    this.chosen_categories = []
                                                                    this.search.categories.map(item => {
                                                                        this.chosen_categories.push(item.id)

                                                                    })
                                                                }
                                                            }
                                                        }),
                                                        m("label.font-weight-bold[for='Al-1']",
                                                            "不限"
                                                        )
                                                    ]
                                                )
                                            ),
                                            m(".h6.pt-20",
                                                "社會住宅"
                                            ),
                                            m("ul.other-features",
                                                [
                                                    this.search.categories.map((category) => {
                                                        if (category.item == 1) {
                                                            return m("li",
                                                                [
                                                                    m(`input[id='al-${category.id}'][type='checkbox']`, {
                                                                        checked: this.chosen_categories.indexOf(category.id) > -1,
                                                                        onclick: (e) => {
                                                                            if (this.chosen_categories.indexOf(category.id) > -1) {
                                                                                this.chosen_categories.splice(this.chosen_categories.indexOf(category.id), 1)
                                                                            } else {
                                                                                this.chosen_categories.push(category.id)
                                                                            }
                                                                        }
                                                                    }),
                                                                    m(`label[for='al-${category.id}']`,
                                                                        category.name
                                                                    )
                                                                ]
                                                            )
                                                        }
                                                    })
                                                ]
                                            ),
                                            m(".h6.pt-20",
                                                "一般出租住宅"
                                            ),
                                            m("ul.other-features",
                                                [
                                                    this.search.categories.map((category) => {
                                                        if (category.item == 2) {
                                                            return m("li",
                                                                [
                                                                    m(`input[id='al-${category.id}'][type='checkbox']`, {
                                                                        checked: this.chosen_categories.indexOf(category.id) > -1,
                                                                        onclick: (e) => {
                                                                            if (this.chosen_categories.indexOf(category.id) > -1) {
                                                                                this.chosen_categories.splice(this.chosen_categories.indexOf(category.id), 1)
                                                                            } else {
                                                                                this.chosen_categories.push(category.id)
                                                                            }
                                                                        }
                                                                    }),
                                                                    m(`label[for='al-${category.id}']`,
                                                                        category.name
                                                                    )
                                                                ]
                                                            )
                                                        }
                                                    })
                                                ]
                                            )
                                        ]
                                    ),
                                    m(".col",
                                        [
                                            m(".h6.pt-20",
                                                "依房數"
                                            ),
                                            m("ul.other-features",
                                                [
                                                    m("li",
                                                        [
                                                            m("input[id='bl-11'][type='checkbox']", {
                                                                checked: this.chosen_houseStyles.length == this.search.houseStyles.length,
                                                                onclick: (e) => {
                                                                    if (this.chosen_houseStyles.length == this.search.houseStyles.length) {
                                                                        this.chosen_houseStyles = []
                                                                    } else {
                                                                        this.chosen_houseStyles = []
                                                                        this.search.houseStyles.map(item => {
                                                                            this.chosen_houseStyles.push(item.id)

                                                                        })
                                                                    }
                                                                }
                                                            }),
                                                            m("label.font-weight-bold[for='bl-11']",
                                                                "不限"
                                                            )
                                                        ]
                                                    ),
                                                    this.search.houseStyles.map((style) => {
                                                        return m("li",
                                                            [
                                                                m(`input[id='bl-${style.id}'][type='checkbox']`, {
                                                                    checked: this.chosen_houseStyles.indexOf(style.id) > -1,
                                                                    onclick: (e) => {
                                                                        if (this.chosen_houseStyles.indexOf(style.id) > -1) {
                                                                            this.chosen_houseStyles.splice(this.chosen_houseStyles.indexOf(style.id), 1)
                                                                        } else {
                                                                            this.chosen_houseStyles.push(style.id)
                                                                        }
                                                                    }
                                                                }),
                                                                m(`label[for='bl-${style.id}']`,
                                                                    style.name
                                                                )
                                                            ]
                                                        )
                                                    })
                                                ]
                                            )
                                        ]
                                    ),
                                    m(".col",
                                        [
                                            m(".h6.pt-20",
                                                "依房屋類型"
                                            ),
                                            m("ul.other-features",
                                                [
                                                    m("li",
                                                        [
                                                            m("input[id='Ol-14'][type='checkbox']", {
                                                                checked: this.chosen_houseTypes.length == this.search.houseTypes.length,
                                                                onclick: (e) => {
                                                                    if (this.chosen_houseTypes.length == this.search.houseTypes.length) {
                                                                        this.chosen_houseTypes = []
                                                                    } else {
                                                                        this.chosen_houseTypes = []
                                                                        this.search.houseTypes.map(item => {
                                                                            this.chosen_houseTypes.push(item.id)

                                                                        })
                                                                    }
                                                                }
                                                            }),
                                                            m("label.font-weight-bold[for='Ol-14']",
                                                                "不限"
                                                            )
                                                        ]
                                                    ),
                                                    this.search.houseTypes.map((type) => {
                                                        return m("li",
                                                            [
                                                                m(`input[id='Ol-${type.id}'][type='checkbox']`, {
                                                                    checked: this.chosen_houseTypes.indexOf(type.id) > -1,
                                                                    onclick: (e) => {
                                                                        if (this.chosen_houseTypes.indexOf(type.id) > -1) {
                                                                            this.chosen_houseTypes.splice(this.chosen_houseTypes.indexOf(type.id), 1)
                                                                        } else {
                                                                            this.chosen_houseTypes.push(type.id)
                                                                        }
                                                                    }
                                                                }),
                                                                m(`label[for='Ol-${type.id}']`,
                                                                    type.name
                                                                )
                                                            ]
                                                        )
                                                    })
                                                ]
                                            )
                                        ]
                                    ),
                                    m(".col",
                                        [
                                            m(".h6.pt-20",
                                                "依坪數"
                                            ),
                                            m("ul.other-features",
                                                [
                                                    m("li",
                                                        [
                                                            m("input[id='Ol-21'][type='checkbox']", {
                                                                checked: this.chosen_pains.length == this.search.pains.length,
                                                                onclick: (e) => {
                                                                    if (this.chosen_pains.length == this.search.pains.length) {
                                                                        this.chosen_pains = []
                                                                    } else {
                                                                        this.chosen_pains = []
                                                                        this.search.pains.map(item => {
                                                                            this.chosen_pains.push(item.id)

                                                                        })
                                                                    }
                                                                }
                                                            }),
                                                            m("label.font-weight-bold[for='Ol-21']",
                                                                "不限"
                                                            )
                                                        ]
                                                    ),
                                                    this.search.pains.map((pain) => {
                                                        return m("li",
                                                            [
                                                                m(`input[id='dl-${pain.id}'][type='checkbox']`, {
                                                                    checked: this.chosen_pains.indexOf(pain.id) > -1,
                                                                    onclick: (e) => {
                                                                        if (this.chosen_pains.indexOf(pain.id) > -1) {
                                                                            this.chosen_pains.splice(this.chosen_pains.indexOf(pain.id), 1)
                                                                        } else {
                                                                            this.chosen_pains.push(pain.id)
                                                                        }
                                                                    }
                                                                }),
                                                                m(`label[for='dl-${pain.id}']`,
                                                                    pain.name
                                                                )
                                                            ]
                                                        )
                                                    })
                                                ]
                                            )
                                        ]
                                    )
                                ]
                            )
                        )
                    ]
                ),
                m(".dropdown",
                    [
                        m("a.btn.btn-outline-secondary.dropdown-toggle.btn-block.template-select[aria-expanded='false'][aria-haspopup='true'][data-toggle='dropdown'][href='#'][id='dropdownMenuButton']",
                            "其他條件"
                        ),
                        m(".dropdown-menu[aria-labelledby='dropdownMenuButton']",
                            [
                                m(".h6.pt-20.pl-20",
                                    "其他條件"
                                ),
                                m("ul.other-features.pl-20.pb-15", {
                                    style: {
                                        width: '540px'
                                    }
                                },
                                    [
                                        this.search.conditions.map((condition) => {
                                            return [m("li.mr-1", {
                                                style: {
                                                    "width": "30%"
                                                }
                                            },
                                                [
                                                    m(`input[id='el-${condition.id}'][type='checkbox']`, {
                                                        checked: this.chosen_conditions.indexOf(condition.id) > -1,
                                                        onclick: (e) => {
                                                            if (this.chosen_conditions.indexOf(condition.id) > -1) {
                                                                this.chosen_conditions.splice(this.chosen_conditions.indexOf(condition.id), 1)
                                                            } else {
                                                                this.chosen_conditions.push(condition.id)
                                                            }
                                                        }
                                                    }),
                                                    m(`label[for='el-${condition.id}']`,
                                                        condition.name
                                                    )
                                                ]
                                            )]
                                        })
                                    ]
                                )
                            ]
                        )
                    ]
                ),
                m(".pl-40 pr-40",
                    m(RangeSlider, {
                        min: this.min,
                        max: this.max,
                        start: this.start,
                        end: this.end
                    })
                ),
                m('div', [
                    m('button.rounded-pill.w-75.mx-4.p-0', m('a.w-100.h-100.py-2', {
                        onclick: (e) => {
                            e.preventDefault()
                            this.search_item = {
                                categories: [],
                                districts: [],
                                houseStyles: [],
                                houseTypes: [],
                                pains: [],
                                conditions: [],
                                keyword: this.keyword,
                                range: []
                            }
                            this.chosen_distrcts.map((district) => {
                                this.search_item.districts.push({
                                    id: district
                                })
                            })
                            this.chosen_categories.map((categoriy) => {
                                this.search_item.categories.push({
                                    id: categoriy
                                })
                            })
                            this.chosen_houseStyles.map((houseStyle) => {
                                this.search_item.houseStyles.push({
                                    id: houseStyle
                                })
                            })
                            this.chosen_houseTypes.map((houseType) => {
                                this.search_item.houseTypes.push({
                                    id: houseType
                                })
                            })
                            this.chosen_pains.map((pain) => {
                                this.search_item.pains.push({
                                    id: pain
                                })
                            })
                            this.chosen_conditions.map((condition) => {
                                this.search_item.conditions.push({
                                    id: condition
                                })
                            })
                            this.search_item.range[0] = this.min()
                            this.search_item.range[1] = this.max()


                            $('#json_value').val(JSON.stringify(this.search_item))
                            $.post('/RentHouse/mrt', {
                                search: JSON.stringify(this.search_item)
                            }, function (result) {
                                window.result = result
                                $('#result').val(JSON.stringify(result)).trigger('change')
                            })
                        }
                    }
                        , '搜尋'))
                ]),
            ]
        )

    }
}

class MobileSearchFormMrt {
    constructor() {
        var i = 0
        this.show = false
        this.search = {
            categories: [],
            districts: [],
            houseStyles: [],
            houseTypes: [],
            pains: [],
            conditions: [],
            keyword: "",
            range: []
        }
        this.keyword = ""
        this.chosen_distrcts = []
        this.chosen_categories = []
        this.chosen_houseStyles = []
        this.chosen_houseTypes = []
        this.chosen_pains = []
        this.chosen_conditions = []

        this.search_item = {
            categories: [],
            districts: [],
            houseStyles: [],
            houseTypes: [],
            pains: [],
            conditions: [],
            keyword: "",
            range: []
        }

        this.min = 0
        this.max = 50000

        Search.fetchList().then((responsive) => {
            this.search = responsive
            this.search.districts.map((district) => {
                this.chosen_distrcts.push(district.id)
            })
            this.search.categories.map((category) => {
                this.chosen_categories.push(category.id)
            })
            this.search.houseStyles.map((houseStyle) => {
                this.chosen_houseStyles.push(houseStyle.id)
            })
            this.search.houseTypes.map((houseType) => {
                this.chosen_houseTypes.push(houseType.id)
            })
            this.search.pains.map((pain) => {
                this.chosen_pains.push(pain.id)
            })
        })

        this.item = []
        for (i = 0; i < 10; i++) {
            this.item[i] = []
        }



    }

    view(vnode) {

        return m("form[action='/RentHouse/List'][id='mobileSearch'][method='post']", [
            m("input[id='json_value']", {
                name: 'search',
                type: 'hidden',
                value: JSON.stringify(this.search_item),
            }),
            m("input[id='result']", {
                name: 'result',
                type: 'hidden',
                value: "",
            }),
            m('.row.no-gutters', [
                m('.col-3.white', [
                    m('.dropdown', m("a.text-center.btn.btn-outline-secondary.dropdown-toggle.btn-block.template-select[data-toggle='collapse'][href='#collapseHouse'][role='button'][aria-expanded='false'][aria-controls='collapseHouse']", "房屋選項")),
                    m('.collapse.position-absolute[id="collapseHouse"][data-parent="#mobileSearch"]', {
                        style: {
                            "width": "100vw",
                            "left": "0vw",
                            "zIndex": "1",
                        }
                    }, m('.card.card-body.m-0', [
                        m('.row.no-gutters', [
                            m('.col', [
                                m('.h6', '依物件類型'),
                                m("ul.other-features.d-inline",
                                    m("li.mr-1.w-100",
                                        [
                                            m("input[id='ol-1'][type='checkbox']", {
                                                checked: this.chosen_categories.length == this.search.categories.length,
                                                onclick: (e) => {
                                                    if (this.chosen_categories.length == this.search.categories.length) {
                                                        this.chosen_categories = []
                                                    } else {
                                                        this.chosen_categories = []
                                                        this.search.categories.map(item => {
                                                            this.chosen_categories.push(item.id)

                                                        })
                                                    }
                                                }
                                            }),
                                            m("label.font-weight-bold[for='ol-1']",
                                                "不限"
                                            )
                                        ]
                                    )
                                ),
                                m("ul.other-features",
                                    [
                                        this.search.categories.map((category) => {
                                            return m("li.mr-1.w-100",
                                                [
                                                    m(`input[id='al-${category.id}'][type='checkbox']`, {
                                                        checked: this.chosen_categories.indexOf(category.id) > -1,
                                                        onclick: (e) => {
                                                            if (this.chosen_categories.indexOf(category.id) > -1) {
                                                                this.chosen_categories.splice(this.chosen_categories.indexOf(category.id), 1)
                                                            } else {
                                                                this.chosen_categories.push(category.id)
                                                            }
                                                        }
                                                    }),
                                                    m(`label[for='al-${category.id}']`,
                                                        category.name
                                                    )
                                                ]
                                            )
                                        })
                                    ]
                                ),
                                m('.h6.pt-20', '依房屋類型'),
                                m("ul.other-features",
                                    [
                                        m("li.mr-1.w-100",
                                            [
                                                m("input[id='ol-14'][type='checkbox']", {
                                                    checked: this.chosen_houseTypes.length == this.search.houseTypes.length,
                                                    onclick: (e) => {
                                                        if (this.chosen_houseTypes.length == this.search.houseTypes.length) {
                                                            this.chosen_houseTypes = []
                                                        } else {
                                                            this.chosen_houseTypes = []
                                                            this.search.houseTypes.map(item => {
                                                                this.chosen_houseTypes.push(item.id)

                                                            })
                                                        }
                                                    }
                                                }),
                                                m("label.font-weight-bold[for='ol-14']",
                                                    "不限"
                                                )
                                            ]
                                        ),
                                        this.search.houseTypes.map((type) => {
                                            return m("li.mr-1.w-100",
                                                [
                                                    m(`input[id='cl-${type.id}'][type='checkbox']`, {
                                                        checked: this.chosen_houseTypes.indexOf(type.id) > -1,
                                                        onclick: (e) => {
                                                            if (this.chosen_houseTypes.indexOf(type.id) > -1) {
                                                                this.chosen_houseTypes.splice(this.chosen_houseTypes.indexOf(type.id), 1)
                                                            } else {
                                                                this.chosen_houseTypes.push(type.id)
                                                            }
                                                        }
                                                    }),
                                                    m(`label[for='cl-${type.id}']`,
                                                        type.name
                                                    )
                                                ]
                                            )
                                        })
                                    ]
                                ),
                            ]),
                            m('.col', [
                                m('.h6', '依房數'),
                                m("ul.other-features",
                                    [
                                        m("li.mr-1.w-100",
                                            [
                                                m("input[id='bl-11'][type='checkbox']", {
                                                    checked: this.chosen_houseStyles.length == this.search.houseStyles.length,
                                                    onclick: (e) => {
                                                        if (this.chosen_houseStyles.length == this.search.houseStyles.length) {
                                                            this.chosen_houseStyles = []
                                                        } else {
                                                            this.chosen_houseStyles = []
                                                            this.search.houseStyles.map(item => {
                                                                this.chosen_houseStyles.push(item.id)

                                                            })
                                                        }
                                                    }
                                                }),
                                                m("label.font-weight-bold[for='bl-11']",
                                                    "不限"
                                                )
                                            ]
                                        ),
                                        this.search.houseStyles.map((style) => {
                                            return m("li.mr-1.w-100",
                                                [
                                                    m(`input[id='bl-${style.id}'][type='checkbox']`, {
                                                        checked: this.chosen_houseStyles.indexOf(style.id) > -1,
                                                        onclick: (e) => {
                                                            if (this.chosen_houseStyles.indexOf(style.id) > -1) {
                                                                this.chosen_houseStyles.splice(this.chosen_houseStyles.indexOf(style.id), 1)
                                                            } else {
                                                                this.chosen_houseStyles.push(style.id)
                                                            }
                                                        }
                                                    }),
                                                    m(`label[for='bl-${style.id}']`,
                                                        style.name
                                                    )
                                                ]
                                            )
                                        })
                                    ]
                                ),
                                m('.h6.pt-20', '依坪數'),
                                m("ul.other-features",
                                    [
                                        m("li.mr-1.w-100",
                                            [
                                                m("input[id='ol-21'][type='checkbox']", {
                                                    checked: this.chosen_pains.length == this.search.pains.length,
                                                    onclick: (e) => {
                                                        if (this.chosen_pains.length == this.search.pains.length) {
                                                            this.chosen_pains = []
                                                        } else {
                                                            this.chosen_pains = []
                                                            this.search.pains.map(item => {
                                                                this.chosen_pains.push(item.id)

                                                            })
                                                        }
                                                    }
                                                }),
                                                m("label.font-weight-bold[for='ol-21']",
                                                    "不限"
                                                )
                                            ]
                                        ),
                                        this.search.pains.map((pain) => {
                                            return m("li.mr-1.w-100",
                                                [
                                                    m(`input[id='dl-${pain.id}'][type='checkbox']`, {
                                                        checked: this.chosen_pains.indexOf(pain.id) > -1,
                                                        onclick: (e) => {
                                                            if (this.chosen_pains.indexOf(pain.id) > -1) {
                                                                this.chosen_pains.splice(this.chosen_pains.indexOf(pain.id), 1)
                                                            } else {
                                                                this.chosen_pains.push(pain.id)
                                                            }
                                                        }
                                                    }),
                                                    m(`label[for='dl-${pain.id}']`,
                                                        pain.name
                                                    )
                                                ]
                                            )
                                        })
                                    ]
                                )
                            ])
                        ])
                    ])),
                ]),
                m('.col-3.white', [
                    m('.dropdown', m("a.text-center.btn.btn-outline-secondary.dropdown-toggle.btn-block.template-select[data-toggle='collapse'][href='#collapsePrice'][role='button'][aria-expanded='false'][aria-controls='collapsePrice']", "租金範圍")),
                    m('.collapse.position-absolute[id="collapsePrice"][data-parent="#mobileSearch"]', {
                        style: {
                            "width": "100vw",
                            "left": "-25vw",
                            "zIndex": "1",
                        }
                    }, m('.card.card-body.m-0', [
                        m('.h6.mb-3', '租金範圍'),
                        m('.row.no-gutters', [
                            m('.col-4',
                                m(TextBox, {
                                    oninput: (e) => {
                                        this.min = e.target.value
                                    },
                                    class: 'mt-0 p-2 text-center',
                                    value: this.min,
                                    type: 'number',
                                    placeholder: '最小金額'
                                }),
                            ),
                            m('.col-4.d-flex.align-items-center.px-2', m('span.w-100.rounded-pill', {
                                style: {
                                    'background': "#4bbed9",
                                    'opacity': '0.8',
                                    'padding': '3px 0'
                                }
                            })),
                            m('.col-4',
                                m(TextBox, {
                                    oninput: (e) => {
                                        this.max = e.target.value
                                    },
                                    class: 'mt-0 p-2 text-center',
                                    value: this.max,
                                    type: 'number',
                                    placeholder: '最大金額'
                                }),
                            )
                        ]),
                    ])),
                ]),
                m('.col-3.white', [
                    m('.dropdown', m("a.text-center.btn.btn-outline-secondary.dropdown-toggle.btn-block.template-select[data-toggle='collapse'][href='#collapseOther'][role='button'][aria-expanded='false'][aria-controls='collapseOther']", "其他條件")),
                    m('.collapse.position-absolute[id="collapseOther"][data-parent="#mobileSearch"]', {
                        style: {
                            "width": "100vw",
                            "left": "-50vw",
                            "zIndex": "1",
                        }
                    }, m('.card.card-body.m-0', [
                        m('.h6.mb-3', '其他條件'),
                        m("ul.other-features.pl-2",
                            [
                                this.search.conditions.map((condition) => {
                                    return [m("li.mr-0", {
                                        style: {
                                            "width": "50%"
                                        }
                                    },
                                        [
                                            m(`input[id='el-${condition.id}'][type='checkbox']`, {
                                                checked: this.chosen_conditions.indexOf(condition.id) > -1,
                                                onclick: (e) => {
                                                    if (this.chosen_conditions.indexOf(condition.id) > -1) {
                                                        this.chosen_conditions.splice(this.chosen_conditions.indexOf(condition.id), 1)
                                                    } else {
                                                        this.chosen_conditions.push(condition.id)
                                                    }
                                                }
                                            }),
                                            m(`label[for='el-${condition.id}']`,
                                                condition.name
                                            )
                                        ]
                                    )]
                                })
                            ]
                        )
                    ])),
                ]),
                m('.col-3.white',
                    m("div",
                        m("a.btn.btn-info.px-1.text-center.btn-block.template-select[role='button']", {
                            onclick: (e) => {
                                e.preventDefault()
                                this.search_item = {
                                    categories: [],
                                    districts: [],
                                    houseStyles: [],
                                    houseTypes: [],
                                    pains: [],
                                    conditions: [],
                                    keyword: this.keyword,
                                    range: []
                                }
                                this.chosen_distrcts.map((district) => {
                                    this.search_item.districts.push({
                                        id: district
                                    })
                                })
                                this.chosen_categories.map((categoriy) => {
                                    this.search_item.categories.push({
                                        id: categoriy
                                    })
                                })
                                this.chosen_houseStyles.map((houseStyle) => {
                                    this.search_item.houseStyles.push({
                                        id: houseStyle
                                    })
                                })
                                this.chosen_houseTypes.map((houseType) => {
                                    this.search_item.houseTypes.push({
                                        id: houseType
                                    })
                                })
                                this.chosen_pains.map((pain) => {
                                    this.search_item.pains.push({
                                        id: pain
                                    })
                                })
                                this.chosen_conditions.map((condition) => {
                                    this.search_item.conditions.push({
                                        id: condition
                                    })
                                })
                                this.search_item.range[0] = this.min
                                this.search_item.range[1] = this.max

                                $('#json_value').val(JSON.stringify(this.search_item))
                                $.post('/RentHouse/mrt', {
                                    search: JSON.stringify(this.search_item)
                                }, function (result) {
                                    window.result = result
                                    $('#result').val(JSON.stringify(result)).trigger('change')
                                })

                                $('.collapse').collapse('hide')
                            }
                        },
                            m(".h6.mb-0.text-white", {
                                style: {
                                    "line-height": "1.35"
                                }
                            },
                                "搜尋"
                            ),
                        )
                    )
                )
            ])
        ])
    }
}
window.isMobile = isMobile()
export default (window.isMobile) ? MobileSearchFormMrt : SearchFormMrt